import { render } from "./OauthUpdate.vue?vue&type=template&id=2dcbdd7e"
import script from "./OauthUpdate.vue?vue&type=script&lang=js"
export * from "./OauthUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__